import React, { useEffect, useState } from "react";
import { FaSliders} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import { Link } from "react-router-dom";
import { FaLocationDot, FaCalendarDays, FaEnvelope, FaListUl, FaX, FaFilePdf, FaPhone, FaClock } from "react-icons/fa6"; 

import "./css/Contacto.css";

const Contacto = () => {
  
  return (
    <>
        <Navbar />
        
        <main className="main contacto">
        <div>
                <h2 className="titulo-seccion mayusculas">¿Necesitas ayuda?</h2>

                <div className="contenido mt-15 mb-10">
                    <p>Para que sepas como usar la app y puedas aprovechar todo su potencial,<br></br> hemos hecho un <Link to="/contacto" className="opcion verde bold">video tutorial</Link> que te guiará paso a paso en su uso.</p>
                </div>
                <div className="contenido mt-15 mb-10">
                    <p>Si necesitas ponerte en contacto con nosotros puedes hacerlo en:</p>
                    <p className="align-center mt-10 gap-5"><FaLocationDot className="verde" />Dirección completa del sitio</p>
                    <p className="align-center mt-10 gap-5"><FaPhone className="verde" />123 456 789</p>
                    <p className="align-center mt-10 gap-5"><FaEnvelope className="verde" />info@islacristina.es</p>
                    <p className="align-center mt-10 gap-5"><FaClock className="verde" />De 9:00 a 13:00</p>
                </div>
            </div>

        </main>
    </>
  );
};

export default Contacto;